module.exports = __webpack_public_path__ + "static/media/home-hero-2.c38c586f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-hero-2.jpg
// module id = 132
// module chunks = 0